var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2C14 1.44772 13.5523 1 13 1H6C4.34315 1 3 2.34315 3 4V20C3 21.6569 4.34315 23 6 23H18C19.6569 23 21 21.6569 21 20V9C21 8.44772 20.5523 8 20 8H17C15.3431 8 14 6.65685 14 5V2ZM15.7071 12.7071C16.0976 12.3166 16.0976 11.6834 15.7071 11.2929C15.3166 10.9024 14.6834 10.9024 14.2929 11.2929L11 14.5858L9.70711 13.2929C9.31658 12.9024 8.68342 12.9024 8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071L10.2929 16.7071C10.6834 17.0976 11.3166 17.0976 11.7071 16.7071L15.7071 12.7071Z",
    fill: "#494E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9774 1.17757C16.4681 0.963989 16 1.44777 16 2.00005V5.00005C16 5.55234 16.4477 6.00005 17 6.00005H20C20.5523 6.00005 21.0361 5.53194 20.8225 5.02262C20.73 4.80212 20.5972 4.59721 20.4142 4.41427L17.5858 1.58584C17.4028 1.40289 17.1979 1.27003 16.9774 1.17757Z",
    fill: "#494E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileChecked);
export default __webpack_public_path__ + "static/media/icon-file-checked.dfc7e32da547e1a719191a30164627f8.svg";
export { ForwardRef as ReactComponent };